import React, { useContext, useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Modal, Form, FormGroup, FormControl, Button, Card, Spinner } from "react-bootstrap";
import { AccountContext } from 'components/Account/Account';
import empresas from 'api/empresas';
import DataTable from "react-data-table-component";
import permissionsManagment from "api/permissionsManagment";

function Companies() {
    const { getSession } = useContext(AccountContext);
    const [token, setToken] = useState(null);
    const [apiError, setApiError] = useState(null); // Mensaje de error de la API
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [empresaName, setEmpresaName] = useState(null);
    const [rutEmpresa, setRutEmpresa] = useState(null);

    const [empresa, setEmpresa] = useState(null);

    const [empresaList, setEmpresaList] = useState([]);
    const [filter, setFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [dataFiltered, setDataFiltered] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [permissionsByTenant, setPermissionsByTenant] = useState([]);
    const [permissionsByTenantOriginal, setPermissionsByTenantOriginal] = useState([]);
    const [dynamicSelects, setDynamicSelects] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [formError, setFormError] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successModalMessage, setSuccessModalMessage] = useState(false);

    const initialNewEmpresa = {
        rut: '',
        name: '',
        resolucion: '',
        resolucionfecha: '',
        giro: '',
        direccion: '',
        comuna: '',
        ciudad: '',
        email: '',
        logo: '',
        logoContent: '',
        minimo: 3000,
        pedir: 1000,
        tipodocumento: 39
    };
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newEmpresa, setNewEmpresa] = useState(initialNewEmpresa);
    const [logoPreview, setLogoPreview] = useState('');
    const [createFormError, setCreateFormError] = useState('');

    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [updateData, setUpdateData] = useState({ name: '', email: '', logo: '', logoContent: '' });
    const [updateLogoPreview, setUpdateLogoPreview] = useState('');
    const [updateFormError, setUpdateFormError] = useState('');

    const DOCUMENT_TYPES = [
        { value: 39, label: 'Boleta' },
        { value: 41, label: 'Boleta Exenta' },
        { value: 33, label: 'Factura' },
    ];
    const getDocumentTypeLabel = (value) =>
        DOCUMENT_TYPES.find((t) => t.value === Number(value))?.label || value;

    const [showConfigModal, setShowConfigModal] = useState(false);
    const [configEmpresa, setConfigEmpresa] = useState(null);
    const [configGroups, setConfigGroups] = useState([]);
    const [configLoading, setConfigLoading] = useState(false);
    const [configMode, setConfigMode] = useState('list'); // 'list' | 'form'
    const [editingGroup, setEditingGroup] = useState({ deviceconfiggroup_id: null, name: '', folios: [] });
    const [configError, setConfigError] = useState('');
    const [showDeleteGroupConfirm, setShowDeleteGroupConfirm] = useState(false);
    const [groupToDelete, setGroupToDelete] = useState(null);

    const [showKeyModal, setShowKeyModal] = useState(false);
    const [deviceKey, setDeviceKey] = useState('');
    const [keyEmpresaName, setKeyEmpresaName] = useState('');
    const [keyEmpresaRut, setKeyEmpresaRut] = useState('');
    const [copyMessage, setCopyMessage] = useState('');

    const [showDisableModal, setShowDisableModal] = useState(false);
    const [disableEmpresa, setDisableEmpresa] = useState(null);

    const GIRO_OPCIONES = [
        'EXPLOTACION DE ESTACIONAMIENTOS DE VEHICULOS AUTOMOTORES Y PARQUIMETRO',
        'COMPRA, VENTA Y ALQUILER (EXCEPTO AMOBLADOS) DE INMUEBLES'
    ];
    const [giroTipo, setGiroTipo] = useState(GIRO_OPCIONES[0]);

    const limpiarRut = (rutInput) =>
        rutInput.toString().replace(/\./g, '').replace(/-/g, '').toUpperCase();

    const calcularDV = (cuerpo) => {
        let suma = 0;
        let multiplo = 2;
        for (let i = cuerpo.length - 1; i >= 0; i--) {
            suma += parseInt(cuerpo.charAt(i), 10) * multiplo;
            multiplo = multiplo === 7 ? 2 : multiplo + 1;
        }
        const resto = 11 - (suma % 11);
        return resto === 11 ? '0' : resto === 10 ? 'K' : resto.toString();
    };

    const formatearRut = (rutInput) => {
        const limpio = limpiarRut(rutInput).replace(/[^0-9K]/g, '');
        if (limpio.length === 0) return '';
        if (limpio.length === 1) return limpio;
        const cuerpo = limpio.slice(0, -1).replace(/[^0-9]/g, '');
        const dv = limpio.slice(-1);
        const cuerpoConPuntos = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${cuerpoConPuntos}-${dv}`;
    };

    // Recibe un RUT sin DV (sólo cuerpo) y devuelve formateado con DV calculado.
    const formatearRutSinDV = (cuerpoInput) => {
        if (!cuerpoInput && cuerpoInput !== 0) return '';
        const cuerpo = cuerpoInput.toString().replace(/\D/g, '');
        if (!cuerpo) return '';
        const dv = calcularDV(cuerpo);
        const cuerpoConPuntos = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${cuerpoConPuntos}-${dv}`;
    };

    // Validación de RUT chileno (módulo 11). Acepta con o sin puntos/guion.
    const validarRut = (rutInput) => {
        if (!rutInput) return false;
        const limpio = limpiarRut(rutInput);
        if (!/^[0-9]+[0-9K]$/.test(limpio)) return false;
        const cuerpo = limpio.slice(0, -1);
        const dv = limpio.slice(-1);
        if (cuerpo.length < 7) return false;
        return dv === calcularDV(cuerpo);
    };

    const handleRutChange = (value) => {
        const formateado = formatearRut(value);
        setNewEmpresa((prev) => ({ ...prev, rut: formateado }));
    };

    const handleGiroTipoChange = (value) => {
        setGiroTipo(value);
        if (value !== 'OTRO') {
            setNewEmpresa((prev) => ({ ...prev, giro: value }));
        } else {
            setNewEmpresa((prev) => ({ ...prev, giro: '' }));
        }
    };

    const validarEmail = (emailInput) => {
        if (!emailInput) return false;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput);
    };

    // Permite letras (incl. tildes y ñ), números, espacios y puntuación común. Sin caracteres extraños.
    const TEXTO_REGEX = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9\s.,'\-/#()º]+$/;
    const validarTexto = (value, maxLen) => {
        if (!value) return false;
        if (value.length > maxLen) return false;
        return TEXTO_REGEX.test(value);
    };

    const handleShowCreateModal = () => {
        setNewEmpresa({ ...initialNewEmpresa, giro: GIRO_OPCIONES[0] });
        setGiroTipo(GIRO_OPCIONES[0]);
        setLogoPreview('');
        setCreateFormError('');
        setShowCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setShowCreateModal(false);
        setCreateFormError('');
    };

    const TEXT_FIELDS_NO_TILDE = new Set(['name', 'giro', 'direccion', 'comuna', 'ciudad']);

    const limpiarTildesYApostrofes = (value) => {
        if (typeof value !== 'string') return value;
        return value
            .replace(/['‘’ʼʻ`´]/g, '')
            .split('')
            .map((ch) => {
                if (ch === 'ñ' || ch === 'Ñ') return ch;
                return ch.normalize('NFD').replace(/[̀-ͯ]/g, '');
            })
            .join('');
    };

    const handleNewEmpresaChange = (field, value) => {
        const cleanValue = TEXT_FIELDS_NO_TILDE.has(field)
            ? limpiarTildesYApostrofes(value).toUpperCase()
            : value;
        setNewEmpresa((prev) => ({ ...prev, [field]: cleanValue }));
    };

    const handleLogoChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setCreateFormError('El logo debe ser una imagen.');
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const dataUrl = reader.result; // "data:image/png;base64,XXXX"
            const base64 = typeof dataUrl === 'string' ? dataUrl.split(',')[1] || '' : '';
            setNewEmpresa((prev) => ({
                ...prev,
                logo: file.name,
                logoContent: base64
            }));
            setLogoPreview(dataUrl);
            setCreateFormError('');
        };
        reader.onerror = () => {
            setCreateFormError('No fue posible leer la imagen seleccionada.');
        };
        reader.readAsDataURL(file);
    };

    const validarNuevaEmpresa = () => {
        const { rut, name, resolucion, resolucionfecha, giro, direccion, comuna, ciudad, email, minimo, pedir } = newEmpresa;
        if (!rut || !name || !resolucion || !resolucionfecha || !giro || !direccion || !comuna || !ciudad || minimo === '' || pedir === '') {
            return 'Todos los campos son obligatorios (excepto email y logo).';
        }
        if (!validarRut(rut)) return 'El RUT ingresado no es válido.';
        if (email && !validarEmail(email)) return 'El email ingresado no es válido.';
        if (!validarTexto(giro, 80)) return 'El giro contiene caracteres no permitidos o supera 80 caracteres.';
        if (!validarTexto(direccion, 70)) return 'La dirección contiene caracteres no permitidos o supera 70 caracteres.';
        if (!validarTexto(comuna, 20)) return 'La comuna contiene caracteres no permitidos o supera 20 caracteres.';
        if (!validarTexto(ciudad, 20)) return 'La ciudad contiene caracteres no permitidos o supera 20 caracteres.';
        if (isNaN(Number(resolucion))) return 'La resolución debe ser numérica.';
        if (isNaN(Number(minimo))) return 'El monto mínimo debe ser numérico.';
        if (isNaN(Number(pedir))) return 'El monto a pedir debe ser numérico.';
        return null;
    };

    const handleCreateEmpresa = () => {
        const error = validarNuevaEmpresa();
        if (error) {
            setCreateFormError(error);
            return;
        }
        setCreateFormError('');
        setIsLoading(true);

        const body = {
            rut: limpiarRut(newEmpresa.rut).slice(0, -1),
            name: newEmpresa.name,
            resolucion: Number(newEmpresa.resolucion),
            resolucionfecha: newEmpresa.resolucionfecha,
            giro: newEmpresa.giro,
            direccion: newEmpresa.direccion,
            comuna: newEmpresa.comuna,
            ciudad: newEmpresa.ciudad,
            email: newEmpresa.email,
            logo: newEmpresa.logo,
            logoContent: newEmpresa.logoContent,
            minimo: Number(newEmpresa.minimo),
            pedir: Number(newEmpresa.pedir),
            tipodocumento: Number(newEmpresa.tipodocumento)
        };

        empresas.createEmpresa(body, token).then((response) => {
            console.log('Empresa creada:', response);
            setIsLoading(false);
            setShowCreateModal(false);
            setSuccessModalMessage('La empresa se ha creado correctamente.');
            setShowSuccessModal(true);

            empresas.getEmpresas(token).then((res) => {
                const sortedcompanies = res.data.sort((a, b) => {
                    const companieA = a.name?.toLowerCase() || "";
                    const companieB = b.name?.toLowerCase() || "";
                    return companieA.localeCompare(companieB);
                });
                setEmpresaList(sortedcompanies);
                setDataFiltered(sortedcompanies);
            }).catch((err) => console.error(err));
        }).catch((error) => {
            console.error('Error al crear empresa:', error);
            setIsLoading(false);
            setShowCreateModal(false);
            setApiError(error.response?.data?.message || 'Error al crear la empresa.');
            setShowErrorModal(true);
        });
    };

    const fetchConfigGroups = (tenant_id) => {
        setConfigLoading(true);
        setIsLoading(true);
        empresas.getDeviceConfigGroups(tenant_id, token).then((res) => {
            setConfigGroups(Array.isArray(res.data) ? res.data : (res.data?.items || []));
            setConfigLoading(false);
            setIsLoading(false);
        }).catch((error) => {
            console.error('Error al obtener configuraciones:', error);
            setConfigGroups([]);
            setConfigLoading(false);
            setIsLoading(false);
        });
    };

    const blankFolio = (rut) => ({
        rut: Number(rut) || '',
        tipodocumento: '',
        minimo: 3000,
        pedir: 1000,
    });

    const handleShowConfigModal = (e) => {
        setConfigEmpresa(e);
        setConfigGroups([]);
        setConfigMode('list');
        setEditingGroup({ deviceconfiggroup_id: null, name: '', folios: [] });
        setConfigError('');
        setShowConfigModal(true);
        fetchConfigGroups(e.tenant_id);
    };

    const handleCloseConfigModal = () => {
        setShowConfigModal(false);
        setConfigEmpresa(null);
        setConfigGroups([]);
        setConfigMode('list');
        setEditingGroup({ deviceconfiggroup_id: null, name: '', folios: [] });
        setConfigError('');
    };

    const handleStartCreateGroup = () => {
        setEditingGroup({
            deviceconfiggroup_id: null,
            name: '',
            folios: [blankFolio(configEmpresa?.rut)],
        });
        setConfigError('');
        setConfigMode('form');
    };

    const handleStartEditGroup = (group) => {
        const folios = group.config?.folios || [];
        setEditingGroup({
            deviceconfiggroup_id: group.deviceconfiggroup_id,
            name: group.name || '',
            folios: folios.length > 0
                ? folios.map((f) => ({
                    rut: f.rut,
                    tipodocumento: f.tipodocumento,
                    minimo: f.minimo,
                    pedir: f.pedir,
                }))
                : [blankFolio(configEmpresa?.rut)],
        });
        setConfigError('');
        setConfigMode('form');
    };

    const handleCancelGroupForm = () => {
        setConfigMode('list');
        setEditingGroup({ deviceconfiggroup_id: null, name: '', folios: [] });
        setConfigError('');
    };

    const handleAddFolio = () => {
        setEditingGroup((prev) => ({
            ...prev,
            folios: [...prev.folios, blankFolio(configEmpresa?.rut)],
        }));
    };

    const handleRemoveFolio = (index) => {
        setEditingGroup((prev) => ({
            ...prev,
            folios: prev.folios.filter((_, i) => i !== index),
        }));
    };

    const handleFolioChange = (index, field, value) => {
        setEditingGroup((prev) => ({
            ...prev,
            folios: prev.folios.map((f, i) => i === index ? { ...f, [field]: value } : f),
        }));
    };

    const validarGrupo = (group) => {
        if (!group.name || !group.name.trim()) return 'El nombre del grupo es obligatorio.';
        if (!group.folios || group.folios.length === 0) return 'Agrega al menos un folio.';
        const tiposVistos = new Set();
        for (let i = 0; i < group.folios.length; i++) {
            const f = group.folios[i];
            if (!f.tipodocumento) return `Folio ${i + 1}: selecciona el tipo de documento.`;
            if (tiposVistos.has(Number(f.tipodocumento))) return `Folio ${i + 1}: tipo de documento duplicado.`;
            tiposVistos.add(Number(f.tipodocumento));
            if (f.rut === '' || isNaN(Number(f.rut))) return `Folio ${i + 1}: RUT inválido.`;
            if (f.minimo === '' || isNaN(Number(f.minimo))) return `Folio ${i + 1}: mínimo inválido.`;
            if (f.pedir === '' || isNaN(Number(f.pedir))) return `Folio ${i + 1}: pedir inválido.`;
        }
        return null;
    };

    const handleSaveGroup = () => {
        const error = validarGrupo(editingGroup);
        if (error) {
            setConfigError(error);
            return;
        }
        setConfigError('');
        setConfigLoading(true);
        setIsLoading(true);

        const body = {
            name: editingGroup.name.trim(),
            config: {
                folios: editingGroup.folios.map((f) => ({
                    rut: Number(f.rut),
                    tipodocumento: Number(f.tipodocumento),
                    minimo: Number(f.minimo),
                    pedir: Number(f.pedir),
                })),
            },
        };

        const onDone = () => {
            setConfigMode('list');
            setEditingGroup({ deviceconfiggroup_id: null, name: '', folios: [] });
            fetchConfigGroups(configEmpresa.tenant_id);
        };
        const onError = (error) => {
            console.error('Error al guardar grupo:', error);
            setConfigLoading(false);
            setIsLoading(false);
            setConfigError(error.response?.data?.message || 'Error al guardar el grupo.');
        };

        if (editingGroup.deviceconfiggroup_id) {
            empresas.updateDeviceConfigGroup(configEmpresa.tenant_id, editingGroup.deviceconfiggroup_id, body, token)
                .then(onDone).catch(onError);
        } else {
            empresas.createDeviceConfigGroup(configEmpresa.tenant_id, body, token)
                .then(onDone).catch(onError);
        }
    };

    const handleDeleteGroup = (group) => {
        setGroupToDelete(group);
        setShowDeleteGroupConfirm(true);
    };

    const handleCancelDeleteGroup = () => {
        setShowDeleteGroupConfirm(false);
        setGroupToDelete(null);
    };

    const handleConfirmDeleteGroup = () => {
        if (!groupToDelete) return;
        setShowDeleteGroupConfirm(false);
        setConfigLoading(true);
        setIsLoading(true);
        empresas.deleteDeviceConfigGroup(configEmpresa.tenant_id, groupToDelete.deviceconfiggroup_id, token).then(() => {
            setGroupToDelete(null);
            fetchConfigGroups(configEmpresa.tenant_id);
        }).catch((error) => {
            console.error('Error al eliminar grupo:', error);
            setGroupToDelete(null);
            setConfigLoading(false);
            setIsLoading(false);
            setConfigError(error.response?.data?.message || 'Error al eliminar el grupo.');
        });
    };

    const handleShowKeyModal = (e) => {
        setKeyEmpresaName(e.name);
        setKeyEmpresaRut(e.rut);
        setDeviceKey('');
        setCopyMessage('');
        setShowKeyModal(true);
        setIsLoading(true);

        empresas.getDeviceRegistrationKey(e.tenant_id, token).then((res) => {
            const data = res.data || {};
            setDeviceKey(data.deviceregistrationkey_id || data.deviceregistrationkey || data.key || '');
            setIsLoading(false);
        }).catch((error) => {
            console.error('Error al obtener clave:', error);
            setIsLoading(false);
            setShowKeyModal(false);
            setApiError(error.response?.data?.message || 'Error al obtener la clave de registro.');
            setShowErrorModal(true);
        });
    };

    const handleCloseKeyModal = () => {
        setShowKeyModal(false);
        setDeviceKey('');
        setCopyMessage('');
    };

    const handleCopyKey = () => {
        if (!deviceKey) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(deviceKey).then(() => {
                setCopyMessage('Copiado al portapapeles');
                setTimeout(() => setCopyMessage(''), 2000);
            }).catch(() => {
                setCopyMessage('No fue posible copiar');
            });
        }
    };

    const handleShowDisableModal = (e) => {
        setDisableEmpresa(e);
        setShowDisableModal(true);
    };

    const handleCloseDisableModal = () => {
        setShowDisableModal(false);
        setDisableEmpresa(null);
    };

    const handleConfirmDisable = () => {
        if (!disableEmpresa) return;
        const targetStatus = disableEmpresa.status === 'suspended' ? 'active' : 'suspended';
        const verbo = targetStatus === 'active' ? 'habilitado' : 'deshabilitado';
        setIsLoading(true);
        empresas.updateEmpresaStatus(disableEmpresa.tenant_id, targetStatus, token).then(() => {
            setIsLoading(false);
            setShowDisableModal(false);
            setSuccessModalMessage(`La empresa ${disableEmpresa.name} se ha ${verbo} correctamente.`);
            setShowSuccessModal(true);
            setDisableEmpresa(null);

            empresas.getEmpresas(token).then((res) => {
                const sorted = res.data.sort((a, b) => {
                    const a1 = a.name?.toLowerCase() || "";
                    const b1 = b.name?.toLowerCase() || "";
                    return a1.localeCompare(b1);
                });
                setEmpresaList(sorted);
                setDataFiltered(sorted);
            }).catch((err) => console.error(err));
        }).catch((error) => {
            console.error(`Error al ${verbo === 'habilitado' ? 'habilitar' : 'deshabilitar'} empresa:`, error);
            setIsLoading(false);
            setShowDisableModal(false);
            setDisableEmpresa(null);
            setApiError(error.response?.data?.message || `Error al ${verbo === 'habilitado' ? 'habilitar' : 'deshabilitar'} la empresa.`);
            setShowErrorModal(true);
        });
    };

    const handleShowUpdateModal = (e) => {
        setEmpresa(e);
        setEmpresaName(e.name);
        setRutEmpresa(e.rut);
        setUpdateData({ name: e.name || '', email: e.email || '', logo: '', logoContent: '' });
        setUpdateLogoPreview('');
        setUpdateFormError('');
        setShowUpdateModal(true);
        setIsLoading(true);

        empresas.getEmpresa(e.tenant_id, token).then((res) => {
            const data = res.data || {};
            setUpdateData((prev) => ({
                ...prev,
                name: data.name !== undefined ? data.name : prev.name,
                email: data.email !== undefined ? data.email : prev.email
            }));
            if (data.logo) setUpdateLogoPreview(data.logo);
            setIsLoading(false);
        }).catch((error) => {
            console.error('Error al obtener empresa:', error);
            setIsLoading(false);
        });
    };

    const handleCloseUpdateModal = () => {
        setShowUpdateModal(false);
        setUpdateFormError('');
    };

    const handleUpdateLogoChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setUpdateFormError('El logo debe ser una imagen.');
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            const dataUrl = reader.result;
            const base64 = typeof dataUrl === 'string' ? dataUrl.split(',')[1] || '' : '';
            setUpdateData((prev) => ({ ...prev, logo: file.name, logoContent: base64 }));
            setUpdateLogoPreview(dataUrl);
            setUpdateFormError('');
        };
        reader.onerror = () => {
            setUpdateFormError('No fue posible leer la imagen seleccionada.');
        };
        reader.readAsDataURL(file);
    };

    const handleUpdateEmpresa = () => {
        if (!updateData.name || !updateData.name.trim()) {
            setUpdateFormError('El nombre o razón social es obligatorio.');
            return;
        }
        if (updateData.email && !validarEmail(updateData.email)) {
            setUpdateFormError('El email ingresado no es válido.');
            return;
        }
        setUpdateFormError('');
        setIsLoading(true);

        const body = {};
        body.name = limpiarTildesYApostrofes(updateData.name).trim().toUpperCase();
        body.email = updateData.email;
        if (updateData.logoContent) {
            body.logo = updateData.logo;
            body.logoContent = updateData.logoContent;
        }

        empresas.updateEmpresa(empresa.tenant_id, body, token).then((response) => {
            console.log('Empresa actualizada:', response);
            setIsLoading(false);
            setShowUpdateModal(false);
            setSuccessModalMessage('La empresa se ha actualizado correctamente.');
            setShowSuccessModal(true);

            empresas.getEmpresas(token).then((res) => {
                const sortedcompanies = res.data.sort((a, b) => {
                    const companieA = a.name?.toLowerCase() || "";
                    const companieB = b.name?.toLowerCase() || "";
                    return companieA.localeCompare(companieB);
                });
                setEmpresaList(sortedcompanies);
                setDataFiltered(sortedcompanies);
            }).catch((err) => console.error(err));
        }).catch((error) => {
            console.error('Error al actualizar empresa:', error);
            setIsLoading(false);
            setShowUpdateModal(false);
            setApiError(error.response?.data?.message || 'Error al actualizar la empresa.');
            setShowErrorModal(true);
        });
    };

    const handleShowEditModal = (e) => {
        setIsLoading(true);
        setFormError("");
        setEmpresa(e);
        setEmpresaName(e.name);
        setRutEmpresa(e.rut);
        setShowEditModal(true);

        permissionsManagment.getPermissionsByTenant(e.tenant_id, token).then((response) => {
            console.log("Permisos activados en el tenant:", response.data);

            // Inicializa los selectores dinámicos con los permisos activados
            const initialSelects = response.data.length > 0
                ? response.data.map((permission) => ({ value: permission.permission_id }))
                : [];

            setPermissionsByTenantOriginal(response.data); // Permisos activados en el tenant
            const tenantPermissions = response.data.map((item) => ({
                permission_id: item.permission_id,
            }));
            console.log('initial select:', initialSelects);
            setPermissionsByTenant(tenantPermissions);
            setDynamicSelects(initialSelects);    // Selectores iniciales
            setIsLoading(false);
        }).catch((error) => {
            console.error("Error al obtener permisos del tenant:", error);
            setIsLoading(false);

            // Si hay un error, inicializa con un selector vacío
            setDynamicSelects([]);
        });
    };



    const handleCloseEditModal = () => {
        setShowEditModal(false);
        // setFormError("");

    }

    const handleEditEmpresa = () => {


        setIsLoading(true);
        console.log("original:", permissionsByTenantOriginal)
        console.log("mod:", permissionsByTenant)
        const originalIds = permissionsByTenantOriginal.map((e) => e.permission_id).sort();
        const currentIds = permissionsByTenant.map((e) => e.permission_id).sort();

        console.log(originalIds)
        console.log(currentIds);


        const areEqual = JSON.stringify(originalIds) === JSON.stringify(currentIds);

        if (!areEqual) {
            console.log("Se realizaron cambios, hay que actualizar");

            permissionsManagment.putPermissionsByTenant(empresa.tenant_id, permissionsByTenant, token).then((response) => {
                console.log(response);
                setSuccessModalMessage(" Los permisos y restricciones se han actualizado correctamente.")
                setShowSuccessModal(true); // Mostrar el modal de éxito
                setIsLoading(false);
                setShowEditModal(false);

            }).catch((error) => {
                console.log(error);
                setShowErrorModal(true);
                setShowEditModal(false);
                setApiError("Error al guardar los permisos");

            })

        }




    }

    const handleSelectChange = (index, value) => {
        // Verifica si el permiso ya fue seleccionado en otro selector
        const isDuplicate = dynamicSelects.some((select, i) => i !== index && select.value === value);

        if (isDuplicate) {
            console.log("Es duplicado");
            console.log("dyn:", dynamicSelects);

            // Restablece el valor del último selector a ""
            const newDynamicSelects = [...dynamicSelects];
            newDynamicSelects[index].value = ""; // Restablece el valor del select actual
            setDynamicSelects(newDynamicSelects);

            // Configura el mensaje de error
            setFormError("Este permiso ya ha sido agregado.");
            return; // Salir de la función para no procesar más
        }
        setFormError("");

        // Si no es duplicado, actualiza el estado
        const newDynamicSelects = [...dynamicSelects];
        newDynamicSelects[index].value = value;
        setDynamicSelects(newDynamicSelects);
        const tenantPermissions = newDynamicSelects.map((item) => ({
            permission_id: item.value,
        }));
        setPermissionsByTenant(tenantPermissions);
    };

    const addNewSelect = () => {

        setDynamicSelects((prevSelects) => [...prevSelects, { value: "" }]);
        console.log(dynamicSelects)
    };

    const removeSelect = (index) => {
        setFormError("");
        const newDynamicSelects = dynamicSelects.filter((_, i) => i !== index);
        setDynamicSelects(newDynamicSelects);
        const tenantPermissions = newDynamicSelects.map((item) => ({
            permission_id: item.value,
        }));
        setPermissionsByTenant(tenantPermissions);
    };


    useEffect(() => {

        getSession().then((session) => {
            // return session.idToken.jwtToken
            setToken(session.idToken.jwtToken);
            empresas.getEmpresas(session.idToken.jwtToken).then((response) => {
                const sortedcompanies = response.data.sort((a, b) => {
                    const companieA = a.name?.toLowerCase() || ""; 
                    const companieB = b.name?.toLowerCase() || "";
                    return companieA.localeCompare(companieB);
                });

                setEmpresaList(sortedcompanies);
                setDataFiltered(sortedcompanies);
            }).catch((error) => {
                console.error(error);
            });

            permissionsManagment.getPermissions(session.idToken.jwtToken).then((response) => {
                setPermissions(response.data);
                // console.log('available permissions:', response.data);

            }).catch((error) => {
                console.log(error)
            })
        });


    }, []);


    useEffect(() => {
        const term = filter.toLowerCase().trim();
        const aux = empresaList.filter((element) => {
            const { name, rut, status } = element;
            const matchesTerm = !term
                || (name && name.toLowerCase().includes(term))
                || (rut && rut.toString().includes(term));
            const effectiveStatus = status || 'active';
            const matchesStatus = statusFilter === 'all' || effectiveStatus === statusFilter;
            return matchesTerm && matchesStatus;
        });
        setDataFiltered(aux);
    }, [filter, statusFilter, empresaList]);

    const stats = useMemo(() => {
        const total = empresaList.length;
        let activas = 0;
        let suspendidas = 0;
        empresaList.forEach((e) => {
            const status = e.status || 'active';
            if (status === 'active') activas += 1;
            else if (status === 'suspended') suspendidas += 1;
        });
        return { total, activas, suspendidas };
    }, [empresaList]);

    const statusBadge = (status) => {
        const s = status || 'active';
        if (s === 'active') return { label: 'Activa', variant: 'success' };
        if (s === 'suspended') return { label: 'Deshabilitada', variant: 'warning' };
        return { label: s, variant: 'danger' };
    };

    const columns = [
        {
            name: "Nombre",
            selector: (row) => row.name,
            sortable: true,
            wrap: true,
        },
        {
            name: "Rut",
            selector: (row) => row.rut,
            cell: (row) => formatearRutSinDV(row.rut),
            sortable: true,
            width: '160px',
        },
        {
            name: "Estado",
            selector: (row) => row.status,
            sortable: true,
            cell: (row) => {
                const b = statusBadge(row.status);
                return <span className={`status-badge status-badge--${b.variant}`}>{b.label}</span>;
            },
            width: '160px',
        },
        {
            name: "Acciones",
            cell: (row) => (
                <div className="row-actions">
                    <Button
                        size="sm"
                        className="btn-row btn-row--access"
                        onClick={() => handleShowUpdateModal(row)}
                    >
                        Actualizar
                    </Button>
                    <Button
                        size="sm"
                        className="btn-row btn-row--edit"
                        onClick={() => handleShowEditModal(row)}
                    >
                        Permisos
                    </Button>
                    <Button
                        size="sm"
                        className="btn-row btn-row--config"
                        onClick={() => handleShowConfigModal(row)}
                    >
                        Config
                    </Button>
                    <Button
                        size="sm"
                        className="btn-row btn-row--neutral"
                        onClick={() => handleShowKeyModal(row)}
                    >
                        Clave
                    </Button>
                    <Button
                        size="sm"
                        className={`btn-row ${row.status === 'suspended' ? 'btn-row--enable' : 'btn-row--disable'}`}
                        onClick={() => handleShowDisableModal(row)}
                    >
                        {row.status === 'suspended' ? 'Habilitar' : 'Deshabilitar'}
                    </Button>
                </div>
            ),
            width: '480px',
        },
    ];

    const paginationOpciones = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsText: 'Todos'
    }

    return (
        <Container fluid className="page-container">
            <div className="page-header">
                <div>
                    <h2 className="page-title">Empresas</h2>
                    <p className="page-subtitle">Gestión de empresas, permisos, configuraciones y claves de dispositivos.</p>
                </div>
                <Button className="btn-primary-action btn-primary-action--inline" onClick={handleShowCreateModal}>
                    <i className="nc-icon nc-simple-add" />
                    Crear empresa
                </Button>
            </div>

            <Row className="stats-row">
                <Col xs={12} sm={6} lg={4}>
                    <div className="stat-card stat-card--info">
                        <div className="stat-card__icon"><i className="nc-icon nc-paper-2" /></div>
                        <div className="stat-card__content">
                            <span className="stat-card__label">Total empresas</span>
                            <span className="stat-card__value">{stats.total}</span>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className="stat-card stat-card--success">
                        <div className="stat-card__icon"><i className="nc-icon nc-check-2" /></div>
                        <div className="stat-card__content">
                            <span className="stat-card__label">Activas</span>
                            <span className="stat-card__value">{stats.activas}</span>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={6} lg={4}>
                    <div className="stat-card stat-card--warning">
                        <div className="stat-card__icon"><i className="nc-icon nc-simple-remove" /></div>
                        <div className="stat-card__content">
                            <span className="stat-card__label">Deshabilitadas</span>
                            <span className="stat-card__value">{stats.suspendidas}</span>
                        </div>
                    </div>
                </Col>
            </Row>

            <Card className="data-card">
                <Card.Body>
                    {empresaList.length > 0 ? (
                        <>
                            <div className="data-card__toolbar">
                                <div className="search-input">
                                    <i className="nc-icon nc-zoom-split" />
                                    <input
                                        type="text"
                                        name="search"
                                        value={filter}
                                        autoComplete="off"
                                        placeholder="Filtrar por nombre o rut..."
                                        onChange={(e) => setFilter(e.target.value)}
                                    />
                                </div>
                                <FormControl
                                    as="select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="filter-select"
                                >
                                    <option value="all">Todos los estados</option>
                                    <option value="active">Activas</option>
                                    <option value="suspended">Deshabilitadas</option>
                                </FormControl>
                            </div>
                            <DataTable
                                className="-striped -highlight"
                                fixedHeader={false}
                                columns={columns}
                                data={dataFiltered}
                                pagination
                                paginationComponentOptions={paginationOpciones}
                            />
                        </>
                    ) : (
                        <div className="no-data-message">No hay información disponible.</div>
                    )}
                </Card.Body>
            </Card>

            {/* Modal para crear empresa */}
            <Modal show={showCreateModal} onHide={handleCloseCreateModal} size="lg">
                <Modal.Header>
                    <Modal.Title>Crear Empresa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <label>RUT</label>
                                    <FormControl
                                        type="text"
                                        placeholder="Ej: 76.939.807-K"
                                        value={newEmpresa.rut}
                                        onChange={(e) => handleRutChange(e.target.value)}
                                        isInvalid={newEmpresa.rut !== '' && !validarRut(newEmpresa.rut)}
                                        isValid={newEmpresa.rut !== '' && validarRut(newEmpresa.rut)}
                                    />
                                    {newEmpresa.rut !== '' && !validarRut(newEmpresa.rut) && (
                                        <small style={{ color: 'red' }}>RUT inválido</small>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label>Nombre</label>
                                    <FormControl
                                        type="text"
                                        placeholder="Razón social"
                                        value={newEmpresa.name}
                                        onChange={(e) => handleNewEmpresaChange('name', e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <label>Resolución</label>
                                    <FormControl
                                        type="text"
                                        inputMode="numeric"
                                        placeholder="Número de resolución"
                                        value={newEmpresa.resolucion}
                                        onChange={(e) => handleNewEmpresaChange('resolucion', e.target.value.replace(/\D/g, ''))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label>Fecha resolución</label>
                                    <FormControl
                                        type="date"
                                        value={newEmpresa.resolucionfecha}
                                        onChange={(e) => handleNewEmpresaChange('resolucionfecha', e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <label>Giro</label>
                            <FormControl
                                as="select"
                                value={giroTipo}
                                onChange={(e) => handleGiroTipoChange(e.target.value)}
                            >
                                {GIRO_OPCIONES.map((opt) => (
                                    <option key={opt} value={opt}>{opt}</option>
                                ))}
                                <option value="OTRO">Otro (especificar)</option>
                            </FormControl>
                            {giroTipo === 'OTRO' && (
                                <>
                                    <FormControl
                                        type="text"
                                        className="mt-2"
                                        placeholder="Ingrese el giro"
                                        maxLength={80}
                                        value={newEmpresa.giro}
                                        onChange={(e) => handleNewEmpresaChange('giro', e.target.value)}
                                        isInvalid={newEmpresa.giro !== '' && !validarTexto(newEmpresa.giro, 80)}
                                        isValid={newEmpresa.giro !== '' && validarTexto(newEmpresa.giro, 80)}
                                    />
                                    {newEmpresa.giro !== '' && !validarTexto(newEmpresa.giro, 80) && (
                                        <small style={{ color: 'red' }}>Giro inválido (máx. 80 caracteres, sin símbolos extraños)</small>
                                    )}
                                </>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <label>Dirección</label>
                            <FormControl
                                type="text"
                                placeholder="Dirección"
                                maxLength={70}
                                value={newEmpresa.direccion}
                                onChange={(e) => handleNewEmpresaChange('direccion', e.target.value)}
                                isInvalid={newEmpresa.direccion !== '' && !validarTexto(newEmpresa.direccion, 70)}
                                isValid={newEmpresa.direccion !== '' && validarTexto(newEmpresa.direccion, 70)}
                            />
                            {newEmpresa.direccion !== '' && !validarTexto(newEmpresa.direccion, 70) && (
                                <small style={{ color: 'red' }}>Dirección inválida (máx. 70 caracteres, sin símbolos extraños)</small>
                            )}
                        </FormGroup>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <label>Comuna</label>
                                    <FormControl
                                        type="text"
                                        placeholder="Comuna"
                                        maxLength={20}
                                        value={newEmpresa.comuna}
                                        onChange={(e) => handleNewEmpresaChange('comuna', e.target.value)}
                                        isInvalid={newEmpresa.comuna !== '' && !validarTexto(newEmpresa.comuna, 20)}
                                        isValid={newEmpresa.comuna !== '' && validarTexto(newEmpresa.comuna, 20)}
                                    />
                                    {newEmpresa.comuna !== '' && !validarTexto(newEmpresa.comuna, 20) && (
                                        <small style={{ color: 'red' }}>Comuna inválida (máx. 20 caracteres, sin símbolos extraños)</small>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label>Ciudad</label>
                                    <FormControl
                                        type="text"
                                        placeholder="Ciudad"
                                        maxLength={20}
                                        value={newEmpresa.ciudad}
                                        onChange={(e) => handleNewEmpresaChange('ciudad', e.target.value)}
                                        isInvalid={newEmpresa.ciudad !== '' && !validarTexto(newEmpresa.ciudad, 20)}
                                        isValid={newEmpresa.ciudad !== '' && validarTexto(newEmpresa.ciudad, 20)}
                                    />
                                    {newEmpresa.ciudad !== '' && !validarTexto(newEmpresa.ciudad, 20) && (
                                        <small style={{ color: 'red' }}>Ciudad inválida (máx. 20 caracteres, sin símbolos extraños)</small>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <label>Email</label>
                            <FormControl
                                type="email"
                                placeholder="correo@empresa.cl"
                                value={newEmpresa.email}
                                onChange={(e) => handleNewEmpresaChange('email', e.target.value)}
                                isInvalid={newEmpresa.email !== '' && !validarEmail(newEmpresa.email)}
                                isValid={newEmpresa.email !== '' && validarEmail(newEmpresa.email)}
                            />
                            {newEmpresa.email !== '' && !validarEmail(newEmpresa.email) && (
                                <small style={{ color: 'red' }}>Email inválido</small>
                            )}
                        </FormGroup>
                        <hr />
                        <div className="mb-2">
                            <h5 className="mb-1">Configuración por defecto</h5>
                            <small className="text-muted">
                                Estos valores se usarán como configuración inicial de la empresa. Podrán modificarse luego.
                            </small>
                        </div>
                        <FormGroup>
                            <label>Tipo de documento</label>
                            <FormControl
                                as="select"
                                value={newEmpresa.tipodocumento}
                                onChange={(e) => handleNewEmpresaChange('tipodocumento', Number(e.target.value))}
                            >
                                {DOCUMENT_TYPES.map((t) => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </FormControl>
                        </FormGroup>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <label>Mínimo</label>
                                    <FormControl
                                        type="number"
                                        placeholder="Monto mínimo"
                                        value={newEmpresa.minimo}
                                        onChange={(e) => handleNewEmpresaChange('minimo', e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <label>Pedir</label>
                                    <FormControl
                                        type="number"
                                        placeholder="Monto a pedir"
                                        value={newEmpresa.pedir}
                                        onChange={(e) => handleNewEmpresaChange('pedir', e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <label>Logo (imagen)</label>
                            <FormControl
                                type="file"
                                accept="image/*"
                                onChange={handleLogoChange}
                            />
                            {logoPreview && (
                                <div className="mt-2">
                                    <img
                                        src={logoPreview}
                                        alt="Vista previa del logo"
                                        style={{ maxHeight: '120px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                    {newEmpresa.logo && (
                                        <div><small className="text-muted">Archivo: {newEmpresa.logo}</small></div>
                                    )}
                                </div>
                            )}
                        </FormGroup>
                        {createFormError && <p style={{ color: 'red' }}>{createFormError}</p>}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseCreateModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleCreateEmpresa}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de configuración: grupos con folios */}
            <Modal show={showConfigModal} onHide={handleCloseConfigModal} size="lg">
                <Modal.Header>
                    <Modal.Title>Grupos de configuración</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {configEmpresa && (
                        <>
                            <p className="mb-1"><strong>Empresa:</strong> {configEmpresa.name}</p>
                            <p className="mb-3"><strong>RUT:</strong> {formatearRutSinDV(configEmpresa.rut)}</p>
                        </>
                    )}

                    {configMode === 'list' && (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h5 className="mb-0">Grupos existentes</h5>
                                <Button variant="success" size="sm" onClick={handleStartCreateGroup}>
                                    + Crear grupo
                                </Button>
                            </div>
                            {configLoading && configGroups.length === 0 ? (
                                <p className="text-muted">Cargando...</p>
                            ) : configGroups.length === 0 ? (
                                <p className="text-muted">No hay grupos registrados.</p>
                            ) : (
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Folios</th>
                                            <th style={{ width: '180px' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {configGroups.map((g) => (
                                            <tr key={g.deviceconfiggroup_id}>
                                                <td>{g.name}</td>
                                                <td>
                                                    {(g.config?.folios || []).map((f, idx) => (
                                                        <div key={idx}>
                                                            <small>
                                                                {getDocumentTypeLabel(f.tipodocumento)} — mín: {f.minimo}, pedir: {f.pedir}
                                                            </small>
                                                        </div>
                                                    ))}
                                                </td>
                                                <td>
                                                    <div className="d-flex" style={{ gap: '6px' }}>
                                                        <Button variant="warning" size="sm" onClick={() => handleStartEditGroup(g)}>Editar</Button>
                                                        <Button variant="danger" size="sm" onClick={() => handleDeleteGroup(g)}>Eliminar</Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </>
                    )}

                    {configMode === 'form' && (
                        <>
                            <h5>{editingGroup.deviceconfiggroup_id ? 'Editar grupo' : 'Nuevo grupo'}</h5>
                            <FormGroup>
                                <label>Nombre del grupo</label>
                                <FormControl
                                    type="text"
                                    value={editingGroup.name}
                                    onChange={(e) => setEditingGroup((prev) => ({ ...prev, name: limpiarTildesYApostrofes(e.target.value) }))}
                                />
                            </FormGroup>

                            <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                                <strong>Folios</strong>
                                <Button variant="success" size="sm" onClick={handleAddFolio}>
                                    + Agregar tipo de documento
                                </Button>
                            </div>
                            {editingGroup.folios.length === 0 ? (
                                <p className="text-muted">No hay folios. Agrega al menos uno.</p>
                            ) : (
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>RUT</th>
                                            <th>Tipo de documento</th>
                                            <th>Mínimo</th>
                                            <th>Pedir</th>
                                            <th style={{ width: '70px' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {editingGroup.folios.map((f, idx) => {
                                            const tiposUsados = editingGroup.folios
                                                .map((x, i) => i !== idx ? Number(x.tipodocumento) : null)
                                                .filter((x) => x);
                                            return (
                                                <tr key={idx}>
                                                    <td>
                                                        <FormControl
                                                            type="number"
                                                            size="sm"
                                                            value={f.rut}
                                                            onChange={(e) => handleFolioChange(idx, 'rut', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FormControl
                                                            as="select"
                                                            size="sm"
                                                            value={f.tipodocumento}
                                                            onChange={(e) => handleFolioChange(idx, 'tipodocumento', e.target.value)}
                                                        >
                                                            <option value="">Seleccionar</option>
                                                            {DOCUMENT_TYPES.map((t) => (
                                                                <option
                                                                    key={t.value}
                                                                    value={t.value}
                                                                    disabled={tiposUsados.includes(t.value)}
                                                                >
                                                                    {t.label}{tiposUsados.includes(t.value) ? ' (ya en este grupo)' : ''}
                                                                </option>
                                                            ))}
                                                        </FormControl>
                                                    </td>
                                                    <td>
                                                        <FormControl
                                                            type="number"
                                                            size="sm"
                                                            value={f.minimo}
                                                            onChange={(e) => handleFolioChange(idx, 'minimo', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FormControl
                                                            type="number"
                                                            size="sm"
                                                            value={f.pedir}
                                                            onChange={(e) => handleFolioChange(idx, 'pedir', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Button variant="danger" size="sm" onClick={() => handleRemoveFolio(idx)}>
                                                            -
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </>
                    )}

                    {configError && <p className="mt-3" style={{ color: 'red' }}>{configError}</p>}
                </Modal.Body>
                <Modal.Footer>
                    {configMode === 'form' ? (
                        <>
                            <Button variant="secondary" onClick={handleCancelGroupForm} disabled={configLoading}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleSaveGroup} disabled={configLoading}>
                                Guardar
                            </Button>
                        </>
                    ) : (
                        <Button variant="secondary" onClick={handleCloseConfigModal}>
                            Cerrar
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmación: habilitar / deshabilitar empresa */}
            <Modal show={showDisableModal} onHide={handleCloseDisableModal} centered>
                <Modal.Header>
                    <Modal.Title>
                        {disableEmpresa?.status === 'suspended' ? 'Habilitar empresa' : 'Deshabilitar empresa'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        ¿Seguro que quieres {disableEmpresa?.status === 'suspended' ? 'habilitar' : 'deshabilitar'} la siguiente empresa?
                    </p>
                    {disableEmpresa && (
                        <ul className="list-unstyled mb-2">
                            <li><strong>Nombre:</strong> {disableEmpresa.name}</li>
                            <li><strong>RUT:</strong> {formatearRutSinDV(disableEmpresa.rut)}</li>
                            <li><strong>Estado actual:</strong> {disableEmpresa.status || '—'}</li>
                            {disableEmpresa.email && (
                                <li><strong>Email:</strong> {disableEmpresa.email}</li>
                            )}
                        </ul>
                    )}
                    <small className="text-muted">
                        La empresa quedará marcada como{' '}
                        <code>{disableEmpresa?.status === 'suspended' ? 'active' : 'suspended'}</code>.
                    </small>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDisableModal}>
                        Cancelar
                    </Button>
                    <Button
                        variant={disableEmpresa?.status === 'suspended' ? 'success' : 'danger'}
                        onClick={handleConfirmDisable}
                    >
                        {disableEmpresa?.status === 'suspended' ? 'Habilitar' : 'Deshabilitar'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmación: eliminar grupo de configuración */}
            <Modal show={showDeleteGroupConfirm} onHide={handleCancelDeleteGroup} centered>
                <Modal.Header>
                    <Modal.Title>Confirmar eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        ¿Seguro que quieres eliminar el grupo
                        {' '}<strong>{groupToDelete?.name}</strong>?
                    </p>
                    <small className="text-muted">Esta acción no se puede deshacer.</small>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelDeleteGroup}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDeleteGroup}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para mostrar la clave de registro del dispositivo */}
            <Modal show={showKeyModal} onHide={handleCloseKeyModal} centered>
                <Modal.Header>
                    <Modal.Title>Clave de registro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-1"><strong>Empresa:</strong> {keyEmpresaName}</p>
                    <p className="mb-1"><strong>RUT:</strong> {formatearRutSinDV(keyEmpresaRut)}</p>
                    {deviceKey ? (
                        <>
                            <FormControl
                                type="text"
                                value={deviceKey}
                                readOnly
                                onFocus={(e) => e.target.select()}
                            />
                            {copyMessage && (
                                <small className="text-success">{copyMessage}</small>
                            )}
                        </>
                    ) : (
                        <p className="text-muted">Cargando...</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseKeyModal}>
                        Cerrar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleCopyKey}
                        disabled={!deviceKey}
                    >
                        Copiar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para actualizar empresa (email y logo) */}
            <Modal show={showUpdateModal} onHide={handleCloseUpdateModal}>
                <Modal.Header>
                    <Modal.Title>Actualizar empresa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup>
                            <label>Nombre o razón social</label>
                            <FormControl
                                type="text"
                                value={updateData.name}
                                onChange={(e) => setUpdateData((prev) => ({ ...prev, name: limpiarTildesYApostrofes(e.target.value).toUpperCase() }))}
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>RUT</label>
                            <FormControl type="text" value={formatearRutSinDV(rutEmpresa)} readOnly />
                        </FormGroup>
                        <hr />
                        <FormGroup>
                            <label>Email</label>
                            <FormControl
                                type="email"
                                placeholder="correo@empresa.cl"
                                value={updateData.email}
                                onChange={(e) => setUpdateData((prev) => ({ ...prev, email: e.target.value }))}
                                isInvalid={updateData.email !== '' && !validarEmail(updateData.email)}
                                isValid={updateData.email !== '' && validarEmail(updateData.email)}
                            />
                            {updateData.email !== '' && !validarEmail(updateData.email) && (
                                <small style={{ color: 'red' }}>Email inválido</small>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <label>Logo (imagen)</label>
                            <FormControl
                                type="file"
                                accept="image/*"
                                onChange={handleUpdateLogoChange}
                            />
                            {updateLogoPreview && (
                                <div className="mt-2">
                                    <img
                                        src={updateLogoPreview}
                                        alt="Vista previa del logo"
                                        style={{ maxHeight: '120px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                    {updateData.logo && (
                                        <div><small className="text-muted">Archivo: {updateData.logo}</small></div>
                                    )}
                                </div>
                            )}
                        </FormGroup>
                        {updateFormError && <p style={{ color: 'red' }}>{updateFormError}</p>}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseUpdateModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleUpdateEmpresa}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para editar empresa */}
            <Modal show={showEditModal} onHide={handleCloseEditModal}>
                <Modal.Header>
                    <Modal.Title>Editar empresa</Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <Form>
                        {/* Información General */}
                        <div>
                            <h5>Información de la Empresa</h5>
                            <FormGroup>
                                <label>Nombre de Empresa</label>
                                <FormControl
                                    type="text"
                                    value={empresaName}
                                    readOnly
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Rut</label>
                                <FormControl
                                    type="text"
                                    value={formatearRutSinDV(rutEmpresa)}
                                    readOnly
                                />
                            </FormGroup>
                        </div>

                        <hr />

                        {/* Sección de Permisos */}
                        <div>
                            <h5>Gestión de Permisos</h5>

                            {!isLoading &&
                                <>
                                    {dynamicSelects.length > 0 ? (
                                        dynamicSelects.map((select, index) => (
                                            <FormGroup key={index}>
                                                <label>Seleccionar permiso {index + 1}</label>
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <FormControl
                                                        as="select"
                                                        value={select.value}
                                                        onChange={(e) => handleSelectChange(index, e.target.value)}
                                                    >
                                                        <option value="">Seleccionar permiso</option>
                                                        {permissions.map((option) => (
                                                            <option key={option.permission_id} value={option.permission_id}>
                                                                {option.permission_name}
                                                            </option>
                                                        ))}
                                                    </FormControl>
                                                    {index >= 0 && (
                                                        <Button variant="danger" onClick={() => removeSelect(index)}>
                                                            -
                                                        </Button>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        ))
                                    ) : (
                                        <p>No hay permisos activados. Agrega uno.</p>
                                    )}

                                    {formError && <p style={{ color: "red" }}>{formError}</p>}
                                    <Button variant="success" onClick={addNewSelect}>
                                        + Agregar permiso
                                    </Button>
                                </>
                            }

                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEditModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleEditEmpresa}>
                        Guardar Cambios
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Carga */}
            <Modal show={isLoading} centered backdrop="static" keyboard={false}>
                <Modal.Body className="text-center">
                    <Spinner animation="border" />
                    <p>Cargando...</p>
                </Modal.Body>
            </Modal>

            {/* Modal de Error */}
            <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{apiError}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowErrorModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header>
                    <Modal.Title>Éxito</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{successModalMessage}</p>
                   
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={() => setShowSuccessModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>




        </Container>
    );
};

export default Companies;
